export const GET_LEVELS = 'GET_LEVELS'
export const GET_LEVELS_FOR_TIMETABLE = 'GET_LEVELS_FOR_TIMETABLE'
export const GET_LEVEL = 'GET_LEVEL'
export const ADD_LEVEL = 'ADD_LEVEL'
export const UPDATE_LEVEL = 'UPDATE_LEVEL'
export const VIEW_LEVEL = 'VIEW_LEVEL'
export const DELETE_LEVEL = 'DELETE_LEVEL'
